module.exports = __webpack_public_path__ + "img/girl.4db61d3.svg";